import React from "react";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase";

import ButtonWithIcon from "./ButtonWithIcon";
import { useNavigate } from "react-router-dom";

const SignOutButton = function (props) {
  const navigate = useNavigate();
  const handleSignOut = function (e) {
    e.preventDefault();

    signOut(auth).catch((error) => console.log(error));
    navigate("/");
  };

  return (
    <ButtonWithIcon
      onClick={handleSignOut}
      icon={
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={1}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
          />
        </svg>
      }
      className={props.className}
    >
      Sign out
    </ButtonWithIcon>
  );
};

export default SignOutButton;
